import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../store';

interface AppState {
  isMaintenanceMode: boolean;
}

const initialState: AppState = {
  isMaintenanceMode: false,
};

export const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setMaintenanceMode: (state, action: PayloadAction<boolean>) => {
      if (typeof action.payload === 'boolean') {
        state.isMaintenanceMode = action.payload;
      } else {
        console.warn('setMaintenanceMode received non-boolean payload:', action.payload);
      }
    },
  },
});

export const { setMaintenanceMode } = appStateSlice.actions;

export const selectIsMaintenanceMode = (state: RootState): boolean =>
  state?.appState?.isMaintenanceMode ?? false;

export const appStateReducer = appStateSlice.reducer;
